<template>
  <DocumentSelectionListItem :document="item" downloadable class="text-text-secondary">
    <template #under>
      <div class="mt-1">
        <small class="detail-md-regular">
          <app-filesize-display :value="item.size" />
          -
          {{ $t(`${TRANSLATION_KEY_PREFIX}.updateInfo`, { date: updateDate, name: item.updateUser }) }}
        </small>
      </div>
    </template>
    <template #append>
      <RightsDisplayButton
        v-if="canShareVersion"
        :disableButton="noShare"
        :rights="item.rights"
        @click="onShareVersion"
      />

      <DeletePopover
        v-if="canDeleteVersion"
        :item="item"
        @confirm="onDeleteVersionConfirmation"
      />
    </template>
  </DocumentSelectionListItem>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import DocumentSelectionListItem from '@/common/document-selection/DocumentSelectionListItem.vue'
import DeletePopover from '@/common/popover/DeletePopover.vue'
import RightsDisplayButton from '@/common/users/RightsDisplayButton.vue'
import { ISOToShortenedDate } from '@/common/utils/dates'
const TRANSLATION_KEY_PREFIX = 'common.document-versioning.DocumentVersioningHistoryItem'

export default {
  name: 'DocumentVersioningHistoryItem',
  components: {
    DocumentSelectionListItem,
    DeletePopover,
    RightsDisplayButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
    noShare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapState('documents', ['documentsVersioningPane']),
    ...mapGetters('room', ['isCurrentUserPm', 'currentUserRights']),
    canDeleteVersion () {
      return this.deletable && this.isCurrentUserPm
    },
    canShareVersion () {
      return this.item.rights && this.isCurrentUserPm
    },
    updateDate () {
      return ISOToShortenedDate(this.item.updateTime)
    },
  },
  emits: ['delete-version', 'share-version'],
  methods: {
    onDeleteVersionConfirmation () {
      this.$emit('delete-version', this.item)
    },
    onShareVersion () {
      this.$emit('share-version', this.item)
    },
  },
}
</script>
